const env = process.env.NODE_ENV;

const Setting = {
    // 接口请求地址
    apiBaseURL: "/api",
    // baseUrl: process.env.NODE_ENV === 'production' ? "http://manager.qd-aliyun-dmz-ack-internal.haier.net" : "http://manager.qd-aliyun-test-internal.haier.net",
    baseUrl: "http://oid.haier.com",
    fileUrl: "/api/textAndFile/uploadFile"
};

export default Setting;
